import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export default function PaymentsAdmin() {
  const [ids, setIds] = useState([]);
  const [active, setActive] = useState(0);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => api.get("/admin/payment-ids").then((r) => { setIds(r.data.upi_ids); setActive(r.data.active_index); }).catch((e) => toast.error(e.response?.data?.detail || "Error")), []);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/payment-ids", { upi_ids: ids, active_index: active });
      setIds(data.upi_ids); setActive(data.active_index);
      toast.success("Payment UPI IDs saved");
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-2xl">
      <h1 className="font-serif text-3xl mb-2">Payments</h1>
      <p className="text-xs text-[#8C867D] mb-6 uppercase tracking-widest">Receiver UPI / GPay IDs (max 10) · Super Admin only</p>
      <div className="admin-surface p-6 space-y-3">
        {ids.map((id, i) => (
          <div key={`upi-${i}-${id || "new"}`} className="flex items-center gap-3">
            <input type="radio" name="active-upi" checked={active === i} onChange={() => setActive(i)} data-testid={`payment-active-${i}`} />
            <input value={id} onChange={(e) => setIds(ids.map((x, j) => j === i ? e.target.value : x))} className="admin-input flex-1 font-mono text-sm" data-testid={`payment-upi-input-${i}`} />
            {ids.length > 1 && (
              <button onClick={() => { setIds(ids.filter((_, j) => j !== i)); if (active >= i && active > 0) setActive(active - 1); }} data-testid={`payment-remove-${i}`}><Trash2 size={15} className="text-[#8C867D] hover:text-[#5B1C22]" /></button>
            )}
          </div>
        ))}
        {ids.length < 10 && (
          <button onClick={() => setIds([...ids, ""])} className="flex items-center gap-2 text-xs uppercase tracking-widest text-[#C5A059]" data-testid="payment-add"><Plus size={14} /> Add UPI ID</button>
        )}
        <p className="text-xs text-[#8C867D]">The selected (radio) ID receives all customer payments — checkout QR codes and UPI links update instantly.</p>
        <button onClick={save} disabled={busy} className="bg-[#C5A059] text-[#121212] px-6 py-2 text-xs uppercase tracking-widest" data-testid="payment-save">{busy ? "…" : "Save"}</button>
      </div>
    </div>
  );
}
